(() => {
  if (window.feitoriaProductGalleryReady) return;
  window.feitoriaProductGalleryReady = true;
  const init = (scope = document) => {
    const galleries = Array.from(scope.querySelectorAll('[data-product-gallery]'));
    if (scope.matches?.('[data-product-gallery]')) galleries.unshift(scope);
    galleries.forEach(gallery => {
      if (gallery.dataset.galleryReady === 'true') return;
      const main = gallery.querySelector('.fs-gallery-image');
      const opener = gallery.querySelector('[data-gallery-open]');
      if (!main || !opener) return;
      gallery.dataset.galleryReady = 'true';
      const thumbnails = gallery.querySelector('[data-gallery-thumbnails]');
      const buttons = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const zoom = gallery.querySelector('[data-gallery-zoom]');
      const selectImage = button => {
        main.srcset = button.dataset.gallerySrcset;
        main.src = button.dataset.gallerySrc;
        main.alt = button.dataset.galleryAlt;
        main.width = Number(button.dataset.galleryWidth);
        main.height = Number(button.dataset.galleryHeight);
        opener.href = button.dataset.galleryZoomSrc;
        buttons.forEach(candidate => candidate.setAttribute('aria-pressed', String(candidate === button)));
        if (dialog?.open && zoom) {
          zoom.src = opener.href;
          zoom.alt = main.alt;
          zoom.width = main.width;
          zoom.height = main.height;
        }
      };
      buttons.forEach(button => button.addEventListener('click', () => selectImage(button)));
      const productRoot = gallery.closest('[data-visual-product]');
      let latestChoice;
      let lastSelectionKey;
      const sourceKey = source => {
        if (!source) return '';
        try {
          const url = new URL(source, window.location.origin);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
          ['width', 'height', 'crop', 'format', 'v'].forEach(key => url.searchParams.delete(key));
          url.searchParams.sort();
          return url.origin + url.pathname + url.search;
        } catch {
          return '';
        }
      };
      const choiceButton = choice => {
        const image = choice.closest('.choice-card')?.querySelector('.choice-image');
        if (!image) return null;
        const imageId = image.dataset.choiceImageId;
        if (imageId) {
          const match = buttons.find(button => button.dataset.galleryImageId === imageId);
          if (match) return match;
        }
        const source = sourceKey(image.dataset.choiceImageSource || image.querySelector('img')?.getAttribute('src'));
        if (!source) return null;
        const matches = buttons.filter(button => sourceKey(button.dataset.gallerySource || button.dataset.gallerySrc) === source);
        return matches.length === 1 ? matches[0] : null;
      };
      const syncChoice = (choice, force = false) => {
        const button = choiceButton(choice);
        if (!button) return false;
        const key = 'choice:' + JSON.stringify([choice.name, choice.value, button.dataset.galleryImageId]);
        if (force || key !== lastSelectionKey) selectImage(button);
        lastSelectionKey = key;
        return true;
      };
      const syncVariant = ({variantId, imageId}) => {
        if (latestChoice?.checked && syncChoice(latestChoice)) return;
        if (!variantId) return;
        const nextImageId = String(imageId || (latestChoice?.checked ? '' : gallery.dataset.galleryDefaultImageId) || '');
        const key = 'variant:' + JSON.stringify([String(variantId), nextImageId]);
        if (key === lastSelectionKey) return;
        lastSelectionKey = key;
        const button = buttons.find(candidate => candidate.dataset.galleryImageId === nextImageId);
        if (button) selectImage(button);
      };
      productRoot?.addEventListener('change', event => {
        const choice = event.target;
        if (!choice.matches?.('[data-choice]') || !choice.checked) return;
        latestChoice = choice;
        syncChoice(choice, true);
      }, true);
      productRoot?.addEventListener('feitoria:variant-change', event => syncVariant(event.detail || {}));
      const master = productRoot?.querySelector('[data-variant-master]');
      if (master) syncVariant({variantId: master.value, imageId: master.selectedOptions[0]?.dataset.imageId});
      if (thumbnails) thumbnails.hidden = false;
      if (!dialog || !zoom || typeof dialog.showModal !== 'function') return;
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', dialog.id);
      opener.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (dialog.open) return;
        event.preventDefault();
        zoom.src = opener.href;
        zoom.alt = main.alt;
        zoom.width = main.width;
        zoom.height = main.height;
        dialog.showModal();
        document.documentElement.classList.add('fs-gallery-zoom-open');
      });
      gallery.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (!document.querySelector('[data-gallery-dialog][open]')) document.documentElement.classList.remove('fs-gallery-zoom-open');
        opener.focus({preventScroll: true});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-gallery-dialog][open]').forEach(dialog => dialog.close());
  });
})();
